import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import * as user from './types';

const mutations = {
  [user.SET_USERS](state, users) {
    state.users.isLoading = false;
    if (!users.pagination) {
      users = {
        content: users,
        pagination: {
          totalElements: users.length,
          startReverseIndex: users.length,
        },
      };
    }
    state.users.totalElements = users.pagination
      ? users.pagination.totalElements
      : users.length;
    state.users.totalElements = users.pagination.totalElements;
    let startIdx = users.pagination.startReverseIndex;
    // let startIdx =
    //   widhdrawUsers.pagination.startIndex +
    //   Math.min(widhdrawUsers.users.length, widhdrawUsers.pagination.pageSize);

    const newData = users.content.reduce((p, c) => {
      c.idx = startIdx--;
      c.createdAt = c.createdAt
        ? format(parseISO(c.createdAt), 'yyyy-MM-dd HH:mm')
        : c.createdAt;
      c.updatedAt = c.updatedAt
        ? format(parseISO(c.updatedAt), 'yyyy-MM-dd HH:mm')
        : c.updatedAt;
      c.lastLogged = c.lastLogged
        ? format(parseISO(c.lastLogged), 'yyyy-MM-dd HH:mm')
        : c.lastLogged;
      c.deletedAt = c.deletedAt
        ? format(parseISO(c.deletedAt), 'yyyy-MM-dd HH:mm')
        : c.deletedAt;
      p.push(c);
      return p;
    }, []);
    state.users.data = newData;
    state.users.pagination = users.pagination;
  },
  [user.SET_OWNERS](state, owners) {
    state.owners.isLoading = false;
    if (!owners.pagination) {
      owners = {
        content: owners,
        pagination: {
          totalElements: owners.length,
          startReverseIndex: owners.length,
        },
      };
    }
    state.owners.totalElements = owners.pagination
      ? owners.pagination.totalElements
      : owners.length;
    state.owners.totalElements = owners.pagination.totalElements;
    let startIdx = owners.pagination.startReverseIndex;
    // let startIdx =
    //   widhdrawUsers.pagination.startIndex +
    //   Math.min(widhdrawUsers.users.length, widhdrawUsers.pagination.pageSize);

    const newData = owners.content.reduce((p, c) => {
      c.idx = startIdx--;
      c.createdAt = c.createdAt
        ? format(parseISO(c.createdAt), 'yyyy-MM-dd HH:mm')
        : c.createdAt;
      c.updatedAt = c.updatedAt
        ? format(parseISO(c.updatedAt), 'yyyy-MM-dd HH:mm')
        : c.updatedAt;
      c.lastLogged = c.lastLogged
        ? format(parseISO(c.lastLogged), 'yyyy-MM-dd HH:mm')
        : c.lastLogged;
      p.push(c);
      return p;
    }, []);
    state.owners.data = newData;
    state.owners.pagination = owners.pagination;
  },
  [user.SET_USER](state, data) {
    if (data) {
      data.createdAt = data.createdAt
        ? format(parseISO(data.createdAt), 'yyyy-MM-dd HH:mm')
        : data.createdAt;
      data.lastLogged = data.lastLogged
        ? format(parseISO(data.lastLogged), 'yyyy-MM-dd HH:mm')
        : data.lastLogged;
      data.deletedAt = data.deletedAt
        ? format(parseISO(data.deletedAt), 'yyyy-MM-dd HH:mm')
        : data.deletedAt;
    }

    console.log('[user]');
    console.log(data);
    // [ hsh - 20220113 - 지역을 동네로 줄임 ex) 안암동1가 ]
    if (data.emdAreaName != null) {
      data.emdAreaNameShort = data.emdAreaName.substring(
        data.emdAreaName.lastIndexOf(' ') + 1,
      );
    }

    state.user = data;
  },
  [user.SET_USER_MAIN](state, main) {
    state.main = main;
  },
  [user.USER_RESET_STATE](state) {
    state.user = {};
    state.main = {};
  },
  [user.SET_USER_EMAIL](state, email) {
    state.user.email = email;
  },
  [user.SET_USER_PROFILE](state, data) {
    Object.assign(state.user, {
      data,
    });
  },
  [user.SET_OWNER_PROFILE](state, data) {
    //console.log(data);
    state.owner = data;
  },
  [user.SET_AUTH_AREA](state, data) {
    state.authArea = data;
  },
  [user.SET_AREA_HISTORY](state, data) {
    const { areaId, areaName, codeType } = data;
    let history = localStorage.getItem('areaHistory');
    if (!history) {
      history = new Array();
    } else {
      history = JSON.parse(history);
    }
    const idx = history.findIndex(h => h.areaId === areaId);
    if (idx < 0) {
      if (history.length > 4) {
        history.pop();
      }
      history.insertArrayAt(0, [data]);
      localStorage.setItem('areaHistory', JSON.stringify(history));
    } else {
      const removed = history.splice(idx, 1);
      history.splice(0, 0, removed[0]);
      localStorage.setItem('areaHistory', JSON.stringify(history));
    }
  },
  [user.SET_USER_STATUS](state, data) {
    state.userStatus = data;
  },
};

export default mutations;
